




















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IBasketRoute } from "@/models/baskets";
import Context from "@/mixins/context";

@Component({
  components: {
    BasketProvider: () =>
      import("@/components/app/global/baskets/basket/basketProvider.vue"),
    BasketProvisioningProvider: () =>
      import("@/components/app/global/baskets/basket/provisioningProvider.vue"),
    BasketTopper: () =>
      import("@/components/app/global/baskets/basket/basketTopper.vue"),
    BasketNotifications: () =>
      import("@/components/app/global/baskets/basket/basketNotifications.vue"),
    BasketStepper: () =>
      import("@/components/app/global/baskets/basket/basketStepper.vue"),
    BasketButton: () =>
      import("@/components/app/global/baskets/basket/basketButton.vue"),
    BasketCurrencySwitcher: () =>
      import(
        "@/components/app/global/baskets/basket/basketCurrencySwitcher.vue"
      )
  }
})
export default class Basket extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];
}
